















































import _ from 'lodash';
import { Component, Vue } from 'vue-property-decorator';

import { Setting as terms } from '@/const/terms/mainTerms';
import { ComponentTerms } from '@/const/terms/componentTerms';
import { SetAdvertiser as feedbackTerms } from '@/const/terms/feedback/advertiser';
import { SettingConfirm as confirmTerms} from '@/const/terms/feedback/confirm';

import { ID_TYPE } from '@/const/types';
import { STATUS } from '@/const/status';
import { DefaultOption, TableOptionType } from '@/const/options/DefaultTableOption';
import {
    AdvertiserDataType,
    IAdvertiser,
} from './types';

import { Table as ElTable } from 'element-ui';
import { AxiosError, AxiosResponse } from 'axios';

import Select from '@/components/ElementComponent/Select/index.vue';
import NumberColumn from '@/components/ElementComponent/Column/NumberColumn.vue';
import DateColumn from '@/components/ElementComponent/Column/DateColumn.vue';
import StatusColumn from '@/components/ElementComponent/Column/StatusColumn.vue';
import SelectAllColumn from '@/components/ElementComponent/Column/SelectAllColumn.vue';
import LinkColumn from '@/components/ElementComponent/Column/LinkColumn.vue';

@Component<Advertiser>({
    name: 'Advertiser',
    components: {
        Select,
        NumberColumn,
        DateColumn,
        LinkColumn,
    },
})
export default class Advertiser extends Vue {
    private terms = terms;
    private compTerms = ComponentTerms;
    private confirmTerms = confirmTerms;

    private tableOptions: TableOptionType = DefaultOption;
    private loading: boolean = false;
    private isUtilsCollapsed: boolean = false;
    private deleteConfirmVisible: boolean= false;

    private sort: null | {prop: string, order: string} = null;
    private tableData: AdvertiserDataType = [];
    private selectedAdvertiser: AdvertiserDataType = [];

    private handleSelectionChange(val: AdvertiserDataType): void {
        this.selectedAdvertiser = val;
    }

    private sortChangeHandler({ column, prop, order }: {column: any, prop: string, order: string}) {
        this.sort = prop ? {prop: prop, order: order} : null;
        this.getAdvertiserResponseHandler();
    }
    
    private deleteAdvertisers() {
        this.deleteConfirmVisible = false;
        const adv_company_nos: ID_TYPE[] = this.selectedAdvertiser.map((item: IAdvertiser) => item.no);
        this.loading = true;
        this.$http.adserverAPI.post('DeleteAdvCompany', {
            adv_company_nos: adv_company_nos,
        }).then((res: any) => res.data)
            .then((data: {result: boolean}) => {
                if (data && data.result) {
                    this.$notify.success(feedbackTerms.deleteAdvertiser.success);
                    this.getAdvertiserResponseHandler();
                    return;
                }
                throw new Error(feedbackTerms.deleteAdvertiser.error.fail);
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.deleteAdvertiser.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                this.loading=false;
                throw err;
            })
    }

    private getAdvertiserResponseHandler() {
        this.loading = true;
        this.selectedAdvertiser = [];
        this.getAdvertiserResponse().then((res: any) => res.data)
            .then((data: AdvertiserDataType) => {
                this.tableData = data;
            })
            .catch((err: AxiosError) => {
                if (err.response && (err.response as AxiosResponse).status !== 200) {
                    this.$notify.error(feedbackTerms.getResponse.error.fail);
                } else {
                    this.$notify.error(err.message);
                }
                throw err;
            })
            .finally(()=>{this.loading = false})
    }
    private getAdvertiserResponse() {
        this.setRouteQueryFromFilter();
        const sort = this.sort && this.sort.prop ? `${this.sort.order === 'ascending'? '' : '-'}${this.sort.prop}` : '';
        return this.$http.adserverAPI.post('GetAdvCompanyList', {sort: sort});
    }

    private setRouteQueryFromFilter(){
        const query: {[name: string]: any} = {        }
        this.sort && this.sort.prop && this.sort.order && (query.sort = `${this.sort.order === 'ascending'? '' : '-'}${this.sort.prop}`);

        const newQuery = Object.entries(query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: encodeURIComponent(value)};
        }, {});
        
        if (!(_.isEqual(newQuery, this.$route.query))) {
            this.$router.replace({
                ...this.$route,
                query: newQuery,
            })
        }
    }
    private setRouteQueryToFilter() {
        const query = Object.entries(this.$route.query).reduce((pre: {[name: string]: any}, entry: [string, any]) => {
            const key = entry[0], value = entry[1];
            return {...pre, [key]: decodeURIComponent(value)};
        }, {}) as any;
        
        query.sort !== undefined && (this.sort = (query.sort as string)[0] === '-' ? { 
            order: 'descending', prop: (query.sort as string).slice(1)
        } : {
            order: 'ascending', prop: (query.sort as string)
        });
    }
    private created() {
        this.setRouteQueryToFilter();
    }
    private mounted() {
        this.$nextTick( () => {
            this.getAdvertiserResponseHandler();
        });
    }
}
